import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { DevicePid, EffectIndex, KK } from '@/define/define'

import list_icon from '@/assets/img/device/mg63/icon.png'
import { generateArray } from '@/tool/utility'
import { getDeviceKeySquare } from '../keysquare/keysquare'
import { nd63VKCodes_del } from '../keycode/vkeycode'
import { BaseDevice, CustomLayout } from '@/profiles/base_device'
import { LIGHT_EFFECT_LIST_MG63 } from '../../light/light_effect_list'

export class MG63 extends BaseDevice {
  name: string = 'MG63'
  icon: string = list_icon
  width: number = 630
  square = getDeviceKeySquare(DevicePid.IROKNd63)
  y_number: number = 10
  vkcodes = nd63VKCodes_del

  //  键盘背光灯效参数 从模式1开始，即从流光模式开始，不包含关灯时的参数，一共预留19种灯效参数空间，每种模式9字节
  //0xF1-0xF4
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_MG63

  inoperableKeys: KK[] = [0x01]
  fnDisableKeys: KK[] = []
  fnFactoryKeys: KK[] = [0xe3, 0x52, 0xe6, 0x50, 0x51, 0x4f, 0x29, 0x1e, 0x1f, 0x20, 0x21, 0x22, 0x23, 0x24, 0x25, 0x26, 0x27, 0x2d, 0x2e, 0x2f, 0x30, 0x31, 0x1b]
  customLayout: CustomLayout = {
    0x2a: this.createSquare(2, 2, 74),
    0x2b: this.createSquare(2, 2, 58),
    0x31: this.createSquare(2, 2, 56),
    0x39: this.createSquare(2, 2, 67),
    0x28: this.createSquare(2, 2, 88),
    0xe1: this.createSquare(2, 2, 74),
    0xe0: this.createSquare(2, 2, 50),
    0xe2: this.createSquare(2, 2, 50),
    0xe3: this.createSquare(2, 2, 50),
    0x2c: this.createSquare(2, 2, 250),
  }
  speedAllowValues: number[] = generateArray(0, 101)
  lightAllowValues: number[] = generateArray(0, 101)
  rate: number[] = [8, 4, 2, 1, 0.5, 0.25, 0.125]
  superResponse: boolean = false
  magneticAxis: boolean = true
  lockWin: boolean = true
  maxDelayTimer: number = 2000
}
